import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isLoading: false,
  isLoadingProduct: false,
  isLoadingPerformance: false,
  performance: [],
  productsByVendor: [],
  sales: [],
  units: [],
  transactions: [],
  customers: [],
  avgTicket: [],
  productActiveOrNot: [],
  isLoadingStatistics: false,
  statistics: [],
  vendorComparision: [],
  isLoadingVendorComparision: false,
  productComparision: [],
  isLoadingProductComparision: false,
  comparisionVendorBoxes: [],
};

export const dashboardProviderSlice = createSlice({
  name: "dashboardProviders",
  initialState,
  reducers: {
    setLoading: (state, { payload }) => {
      state.isLoading = payload;
    },
    setData: (state, { payload }) => {
      state.sales = payload.sales;
      state.units = payload.units;
      state.transactions = payload.transactions;
      state.customers = payload.customers;
      state.avgTicket = payload.avgTicket;
    },
    setLoadingProduct: (state, { payload }) => {
      state.isLoadingProduct = payload;
    },
    setProductsByVendors: (state, { payload }) => {
      state.productsByVendor = payload.rows || payload.results || [];
    },
    setLoadingPerformance: (state, { payload }) => {
      state.isLoadingPerformance = payload;
    },
    setPerformance: (state, { payload }) => {
      state.performance = payload;
    },
    setProductActiveOrNot: (state, { payload }) => {
      state.productActiveOrNot = payload
    },
    setLoadingStatistics: (state, { payload }) => {
      state.isLoadingStatistics = payload
    },
    setStatistics: (state, { payload }) => {
      state.statistics = payload
    },
    setLoadingVendorComparision: (state, { payload }) => {
      state.isLoadingVendorComparision = payload
    },
    setVendorComparision: (state, { payload }) => {
      state.vendorComparision = payload
    },
    setLoadingProductComparision: (state, { payload }) => {
      state.isLoadingProductComparision = payload
    },
    setProductComparision: (state, { payload }) => {
      state.productComparision = payload
    },
    resetProviderDashboard: (state) => {
      return initialState;
    },
    setComparisionVendorBoxes: (state, { payload }) => {
      state.comparisionVendorBoxes = payload
    },
  },
});
export const dashboardProviderActions = dashboardProviderSlice.actions;

export default dashboardProviderSlice.reducer;
